"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'register.username.placeholder': 'Ingresa nombre de usuario',
};
